module.exports = __webpack_public_path__ + "media/images/c-adminSidebarLink/fund_type_confirmation_terms-5d25e6b053e8ed67c78baf080cea6054.svg";